import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import CurrentUser from './PublicUserSessionContext';
import { getNextTerminationDate } from '../../../service/functions';
import firebase from 'firebase';

const MS_PER_DAY = 24 * 60 * 60 * 1000;

const EXPIRED_ALERT = {
    title: 'Tu membresía ha expirado',
    message: 'Tu suscripción Premium ha expirado. Renueva tu membresía para seguir disfrutando del contenido exclusivo.'
};

function getMembershipExpirationInfo(user) {
    if (!user) return { canShow: false };

    if (user.type === 'Gratis' && typeof user.subscriptionExpiredAt === 'number') {
        return { canShow: true, expiredGratis: true, content: EXPIRED_ALERT };
    }

    if (!['Premium', 'Legacy'].includes(user.type)) {
        return { canShow: false };
    }

    let expirationDate = null;

    if (typeof user.terminationDate === 'number') {
        expirationDate = user.terminationDate;
    } else if (typeof user.paymentDay === 'number') {
        const hasPremiumAnual = user.hasPremiumAnual === true;
        expirationDate = getNextTerminationDate(user.paymentDay, hasPremiumAnual);
    }

    if (expirationDate == null) {
        return { canShow: false };
    }

    return { expirationDate, canShow: true };
}

function getDaysUntilExpiration(expirationDate) {
    const now = Date.now();
    const diff = expirationDate - now;
    return Math.ceil(diff / MS_PER_DAY);
}

function getAlertContent(expirationDate) {
    const days = getDaysUntilExpiration(expirationDate);

    if (days < 0) {
        return {
            title: 'Tu membresía ha expirado',
            message: 'Tu suscripción Premium ha expirado. Renueva tu membresía para seguir disfrutando del contenido exclusivo.'
        };
    }
    if (days === 0) {
        return {
            title: 'Tu membresía expira hoy',
            message: 'Tu membresía Premium expira hoy. Renueva para no perder el acceso.'
        };
    }
    if (days === 1) {
        return {
            title: 'Tu membresía expira pronto',
            message: 'Tu membresía Premium expira mañana. Renueva para no perder el acceso.'
        };
    }
    return {
        title: 'Tu membresía expira pronto',
        message: `Tu membresía Premium expira en ${days} días. Renueva para no perder el acceso.`
    };
}

class MembershipExpirationAlertComponent extends Component {
    state = { show: false, content: null, hasDismissedThisSession: false };
    _lastEvaluatedUserId = null;

    evaluateAlert = () => {
        if (this.state.hasDismissedThisSession) return;

        const { currentUser } = this.context;
        if (!currentUser?.id) return;
        if (this._lastEvaluatedUserId === currentUser.id) return;
        this._lastEvaluatedUserId = currentUser.id;

        if (currentUser.dismissedMembershipExpirationAlert) return;

        const result = getMembershipExpirationInfo(currentUser);
        if (!result.canShow) return;

        if (result.expiredGratis) {
            this.setState({ show: true, content: result.content });
            return;
        }

        const days = getDaysUntilExpiration(result.expirationDate);
        if (days > 7) return;

        this.setState({ show: true, content: getAlertContent(result.expirationDate) });
    };

    componentDidMount() {
        this.evaluateAlert();
    }

    componentDidUpdate() {
        this.evaluateAlert();
    }

    handleDismiss = () => {
        const { currentUser } = this.context;
        if (!currentUser?.id) return;

        this.setState({ hasDismissedThisSession: true, show: false });

        firebase.firestore().collection('users').doc(currentUser.id).update({
            dismissedMembershipExpirationAlert: true
        }).catch((err) => {
            console.error('Error al descartar alerta:', err);
        });
    };

    render() {
        const { show, content } = this.state;
        if (!show || !content) return null;

        return (
            <Modal show={show} onHide={this.handleDismiss} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{content.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="mb-0">{content.message}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={this.handleDismiss}>
                        Entendido
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

MembershipExpirationAlertComponent.contextType = CurrentUser;

export default MembershipExpirationAlertComponent;
